import { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { type UsersForumPage, type UsersForumSortBy } from '../models/engagement-users'
import { GetUsersForumQuery } from '../../data/queries/get-users-forum.query'
import { type UsersForumPageEntity } from '../../data/entities/users.entity'

export interface GetUsersForumParams {
  fromDate: string
  toDate: string
  fromPrevious: string
  toPrevious: string
  sortBy: UsersForumSortBy
  sortOrder: 'asc' | 'desc'
  offset: number
  limit: number
  organization: string
}

export class GetUsersForumInteractor {
  constructor(private readonly repository: GetInteractor<UsersForumPageEntity>) {}

  public async execute(params: GetUsersForumParams): Promise<UsersForumPage> {
    return await this.repository.execute(
      new GetUsersForumQuery(
        params.fromDate,
        params.toDate,
        params.fromPrevious,
        params.toPrevious,
        params.sortBy,
        params.sortOrder,
        params.offset,
        params.limit,
        params.organization
      )
    )
  }
}
